import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Button, Divider, Header, Message, Icon, Segment } from 'semantic-ui-react';
import { useAuth } from '../context/AuthContext';
import logo from '../resources/logo.png';

function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({ fullName: '', email: '', phone: '', password: '', confirm: '' });
  const [errors, setErrors]   = useState({});
  const [apiError, setApiError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const update = (field, value) => setForm(f => ({ ...f, [field]: value }));

  const validate = () => {
    const e = {};
    if (!form.fullName.trim())      e.fullName = 'Full name is required.';
    if (!/\S+@\S+\.\S+/.test(form.email)) e.email = 'Enter a valid email address.';
    if (!/^\d{10}$/.test(form.phone))     e.phone = 'Enter a valid 10-digit phone number.';
    if (form.password.length < 6)         e.password = 'Password must be at least 6 characters.';
    if (form.password !== form.confirm)   e.confirm = 'Passwords do not match.';
    return e;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setApiError('');
    const errs = validate();
    setErrors(errs);
    if (Object.keys(errs).length) return;

    setLoading(true);
    setTimeout(() => {
      const result = register({ fullName: form.fullName.trim(), email: form.email.trim(), phone: form.phone.trim(), password: form.password });
      setLoading(false);
      if (!result.ok) { setApiError(result.error); return; }
      navigate('/login', { state: { registered: true } });
    }, 400);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <Segment style={{ width: '100%', maxWidth: 560, padding: 36 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 20 }}>
          <img src={logo} alt="BHU" style={{ height: 52, width: 'auto', flexShrink: 0 }} />
          <div>
            <Header as="h1" style={{ margin: 0, fontSize: '1.1rem' }} content="Atithi" />
            <p style={{ margin: 0, opacity: 0.6 }}>Banaras Hindu University</p>
          </div>
        </div>

        <Divider />

        <Header as="h2" content="Create an Account" subheader="Register to book guest house rooms at BHU" />

        {apiError && (
          <Message negative>
            <Icon name="exclamation circle" />
            {apiError}
          </Message>
        )}

        <Form onSubmit={handleSubmit}>
          <Form.Group widths="equal">
            <Form.Input
              label="Full Name"
              icon="user outline"
              iconPosition="left"
              placeholder="Dr. / Prof. / Mr. / Ms."
              value={form.fullName}
              onChange={e => update('fullName', e.target.value)}
              error={errors.fullName ? { content: errors.fullName, pointing: 'above' } : false}
            />

            <Form.Input
              label="Mobile Number"
              icon="phone"
              iconPosition="left"
              placeholder="10-digit mobile number"
              value={form.phone}
              onChange={e => update('phone', e.target.value)}
              maxLength={10}
              error={errors.phone ? { content: errors.phone, pointing: 'above' } : false}
            />
          </Form.Group>

          <Form.Input
            label="Email Address"
            icon="envelope outline"
            iconPosition="left"
            placeholder="you@bhu.ac.in"
            value={form.email}
            onChange={e => update('email', e.target.value)}
            error={errors.email ? { content: errors.email, pointing: 'above' } : false}
          />

          <Form.Group widths="equal">
            <Form.Input
              label="Password"
              type={showPass ? 'text' : 'password'}
              icon="lock"
              iconPosition="left"
              placeholder="Min. 6 characters"
              value={form.password}
              onChange={e => update('password', e.target.value)}
              error={errors.password ? { content: errors.password, pointing: 'above' } : false}
              action={{
                type: 'button',
                basic: true,
                icon: showPass ? 'eye slash' : 'eye',
                onClick: () => setShowPass(p => !p),
              }}
            />

            <Form.Input
              label="Confirm Password"
              type={showPass ? 'text' : 'password'}
              icon="lock"
              iconPosition="left"
              placeholder="Re-enter password"
              value={form.confirm}
              onChange={e => update('confirm', e.target.value)}
              error={errors.confirm ? { content: errors.confirm, pointing: 'above' } : false}
            />
          </Form.Group>

          <Button
            type="submit"
            color="blue"
            loading={loading}
            disabled={loading}
            fluid
          >
            {!loading && <Icon name="user plus" />}
            Create Account
          </Button>
        </Form>

        <p style={{ marginTop: 18, textAlign: 'center', fontSize: '0.88rem', opacity: 0.7 }}>
          Already have an account?{' '}
          <Link to="/login" style={{ fontWeight: 700, color: 'var(--primary)' }}>Sign in here</Link>
        </p>
      </Segment>
    </div>
  );
}

export default RegisterPage;
